<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">Corbeille</v-list-item-title>
        <v-list-item-subtitle>Vous souhaitez obtenir </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-0">
      <v-tabs color="primary">
        <v-tab @click="datasourceContact.refresh()">
          {{ this.$t('recherche.rechercheSimple.tabs.contact') }}
        </v-tab>
        <v-tab @click="datasourcePersonneMorale.refresh()">
          {{ this.$t('recherche.rechercheSimple.tabs.personneMorale') }}
        </v-tab>
        <v-tab @click="datasourceInstance.refresh()">
          {{ this.$t('recherche.rechercheSimple.tabs.instance') }}
        </v-tab>
        <v-tab @click="datasourcePersonnePhysique.refresh()">
          {{ this.$t('recherche.rechercheSimple.tabs.personnePhysique') }}
        </v-tab>
        <!-- recherche contact -->
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="nom"
                @storeSearch="storeSearch('contact', 'nom', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="prenom"
                @storeSearch="storeSearch('contact', 'prenoms', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourceContact"
                attr="raisonSociale"
                @storeSearch="storeSearch('contact', 'raisonSociale', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.raisonSociale"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedRechercheSimple"
            :datasource="datasourceContact"
            @item-selected="selectedItemTraitements"
            :callRefresh="callRefresh"
            ref="datasourceRef"
          >
            <template #item.raisonSociale="{item}">
              <router-link :to="$liens().personneMorale(item.idPersonneMorale)"
                >{{ item.raisonSociale }}
              </router-link>
            </template>

            <template #item.nom="{item}">
              <navigable-link
                :to="{
                  name: 'administration/corbeille/personne-physique/detail',
                  params: { id: item.idPersonnePhysique },
                }"
              >
                {{ item.nom }}
              </navigable-link>
            </template>
            <template #item.prenoms="{item}">
              <navigable-link
                :to="{
                  name: 'administration/corbeille/personne-physique/detail',
                  params: { id: item.idPersonnePhysique },
                }"
              >
                {{ item.prenoms }}
              </navigable-link>
            </template>

            <template #item.telephone="{item}">
              {{ item.telephone }}
              <v-tooltip v-if="item.telephoneConfidentiel" bottom>
                <template #activator="{ on }">
                  <v-icon v-on="on">mdi-eye-off</v-icon>
                </template>
                <span>Confidentiel</span>
              </v-tooltip>
            </template>
            <template #item.dateSuppression="{item}">
              {{ formatDate(item.dateSuppression) }}
            </template>
          </datasource-table>
        </v-tab-item>

        <!-- recherche personne morale -->
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourcePersonneMorale"
                attr="raisonSociale"
                @storeSearch="
                  storeSearch('personneMorale', 'raisonSociale', $event)
                "
                i18n="recherche.rechercheSimple.personneMorale.search.raisonSociale"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourcePersonneMorale"
                attr="departement"
                @storeSearch="
                  storeSearch('personneMorale', 'departement', $event)
                "
                i18n="recherche.rechercheSimple.personneMorale.search.departement"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedRechercheSimple"
            :datasource="datasourcePersonneMorale"
            @item-selected="selectedItemTraitements"
            :callRefresh="callRefresh"
            ref="datasourceRef"
          >
            <template #item.nomUsuel="{item}">
              <navigable-link
                :to="{
                  name: 'administration/corbeille/personne-morale/detail',
                  params: { id: item.id },
                }"
              >
                {{ item.nomUsuel }}
              </navigable-link>
            </template>
            <template #item.raisonSociale="{item}">
              <navigable-link
                :to="{
                  name: 'administration/corbeille/personne-morale/detail',
                  params: { id: item.id },
                }"
              >
                {{ item.raisonSociale }}
              </navigable-link>
            </template>
            <template #item.dateSuppression="{item}">
              {{ formatDate(item.dateSuppression) }}
            </template>
          </datasource-table>
        </v-tab-item>
        <!-- recherche Instance-->
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourceInstance"
                attr="nom"
                @storeSearch="storeSearch('instance', 'nom', $event)"
                i18n="recherche.rechercheSimple.instance.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasourceInstance"
                attr="id"
                typeChamp="number"
                @storeSearch="storeSearch('instance', 'idInstance', $event)"
                i18n="recherche.rechercheSimple.instance.search.id"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedRechercheSimple"
            :datasource="datasourceInstance"
            @item-selected="selectedItemTraitements"
            :callRefresh="callRefresh"
            ref="datasourceRef"
          >
            <template #item.nom="{item}">
              <navigable-link
                :to="{
                  name: 'administration/corbeille/instance/detail',
                  params: { id: item.id },
                }"
              >
                {{ item.nom }}
              </navigable-link>
            </template>
            <template #item.dateSuppression="{item}">
              {{ formatDate(item.dateSuppression) }}
            </template>
          </datasource-table>
        </v-tab-item>

        <!-- recherche personne physique -->
        <v-tab-item>
          <v-row>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourcePersonnePhysique"
                attr="nom"
                @storeSearch="storeSearch('personnePhysique', 'nom', $event)"
                i18n="recherche.rechercheSimple.personnePhysique.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasourcePersonnePhysique"
                attr="prenom"
                @storeSearch="
                  storeSearch('personnePhysique', 'prenoms', $event)
                "
                i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
              />
            </v-col>
          </v-row>

          <datasource-table
            v-model="selectedRechercheSimple"
            :datasource="datasourcePersonnePhysique"
            @item-selected="selectedItemTraitements"
            :callRefresh="callRefresh"
            ref="datasourceRef"
          >
            <template #item.dateSuppression="{item}">
              {{ formatDate(item.dateSuppression) }}
            </template>
          </datasource-table>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import Datasource from '@/utils/datasource';
import moment from 'moment';

export default {
  props: {
    fieldName: {
      type: Array,
      default() {
        return ['_select-one'];
      },
    },
    capabilities: {
      type: String,
      default: 'create,search',
    },
    selectAll: {
      type: Boolean,
      default: true,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.datasourceContact.refresh();
    this.$store.commit('origine/recherche', {
      recherche: 'recherchesimple',
    });
  },
  data() {
    const DATE_SUPPR = this.$t('corbeille.dateSuppression');
    const datasourceContact = new Datasource('corbeille/contact', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      selectAll: this.selectAll,
      labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
      args: {},
      fields: [
        {
          value: 'nom',
          sortable: true,
        },
        {
          value: 'prenoms',
          sortable: true,
        },
        {
          value: 'raisonSociale',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
          ),
        },

        {
          value: 'fonction',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
          ),
        },
        {
          value: 'telephone',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
          ),
        },
        {
          value: 'mail',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.personnePhysique.list.headers.mail',
          ),
        },
        {
          value: 'dateSuppression',
          sortable: true,
          text: DATE_SUPPR,
        },
      ],
    });

    const datasourcePersonneMorale = new Datasource(
      'corbeille/personne-morale',
      {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nomUsuel'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
        args: {},
        fields: [
          {
            value: 'nomUsuel',
            sortable: true,
            linkTo: true,
            linkUrl: 'recherche/recherchesimple/personne-morale/detail',
            linkId: 'id',
          },
          {
            value: 'raisonSociale',
            sortable: true,
            linkTo: true,
            linkUrl: 'recherche/recherchesimple/personne-morale/detail',
            linkId: 'id',
          },
          {
            value: 'departement',
            sortable: false,
          },
          {
            value: 'ville',
            sortable: false,
          },
          {
            value: 'telephone',
            sortable: false,
          },
          {
            value: 'dateSuppression',
            sortable: true,
            text: DATE_SUPPR,
          },
        ],
      },
    );

    const datasourceInstance = new Datasource('corbeille/instance', {
      page: 1,
      rowsPerPage: 20,
      sortBy: ['nom'],
      descending: [false],
      selectAll: this.selectAll,
      labelNamespace: 'recherche.rechercheSimple.instance.list',
      args: {
        actif: true,
      },
      fields: [
        {
          value: 'nom',
          sortable: true,
          linkTo: true,
          linkUrl: 'recherche/recherchesimple/instance/detail',
          linkId: 'id',
          text: this.$t('recherche.rechercheSimple.instance.list.headers.nom'),
        },
        {
          value: 'referent',
          sortable: true,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.referent',
          ),
        },
        {
          value: 'nomsGestionnaires',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.personnePhysique',
          ),
        },
        {
          value: 'size',
          sortable: false,
          text: this.$t(
            'recherche.rechercheSimple.instance.list.headers.numberOfUser',
          ),
        },
        {
          value: 'dateSuppression',
          sortable: true,
          text: DATE_SUPPR,
        },
      ],
    });

    const datasourcePersonnePhysique = new Datasource(
      'corbeille/personne-physique',
      {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        selectAll: this.selectAll,
        labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
        args: {},
        fields: [
          {
            value: 'nom',
            sortable: true,
          },
          {
            value: 'prenoms',
            sortable: true,
          },
          {
            value: 'dateSuppression',
            sortable: true,
            text: DATE_SUPPR,
          },
        ],
      },
    );

    const initialSearch = this.$store.state.search.oldSearchField;
    datasourceContact.page = initialSearch.contact.page;
    Object.entries(initialSearch.contact.args).forEach(element => {
      datasourceContact.args[element[0]] = element[1];
    });

    datasourceInstance.page = initialSearch.instance.page;
    Object.entries(initialSearch.instance.args).forEach(element => {
      datasourceInstance.args[element[0]] = element[1];
    });

    datasourcePersonneMorale.page = initialSearch.personneMorale.page;
    Object.entries(initialSearch.personneMorale.args).forEach(element => {
      datasourcePersonneMorale.args[element[0]] = element[1];
    });

    return {
      datasourceContact,
      datasourcePersonneMorale,
      datasourceInstance,
      datasourcePersonnePhysique,
      selectedRechercheSimple: [],

      form: {},
      column: null,
      row: null,
      active: 1,
    };
  },
  methods: {
    storeSearch(entity, fieldName, value) {
      this.$store.commit('search/updateSearchField', {
        entity: entity,
        field: fieldName,
        value: value,
      });
    },
    selectedItemTraitements(item) {
      this.$emit('item-selected', item);
    },
    changeCallRefreshValue(val) {
      this.$refs.datasourceRef.changeCallRefreshValue(val);
      this.$refs.datasourceRef.datasourceRefresh();
    },
    formatDate(date) {
      return date ? moment(date).format('DD/MM/YYYY') : null;
    },
  },
};
</script>
